import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=ca0accba&scoped=true"
import script from "./cards.vue?vue&type=script&lang=js"
export * from "./cards.vue?vue&type=script&lang=js"
import style0 from "./cards.vue?vue&type=style&index=0&id=ca0accba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0accba",
  null
  
)

export default component.exports